var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Rectangle"),React.createElement("g",{"id":"design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"1440_media","transform":"translate(-454.000000, -926.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"player","transform":"translate(40.000000, 862.000000)"},React.createElement("g",{"id":"video-1-copy","transform":"translate(0.000000, 58.000000)"},React.createElement("polygon",{"id":"Rectangle","points":"414 6 423 10.5 414 15"})))))]);
}

Play.defaultProps = {"width":"9px","height":"9px","viewBox":"0 0 9 9","version":"1.1"};

module.exports = Play;

Play.default = Play;
